import clsx from "clsx";
import type { Size } from "../types";
import { spinnerTheme as theme } from "./theme";

export default function Spinner({
  size = "md",
  buttonSpinner,
  color = "default",
}: {
  size: Size;
  buttonSpinner?: boolean;
  color?: "default" | "inverse";
}) {
  return (
    <div role="status" className="leading-none">
      <svg
        aria-hidden="true"
        className={clsx(
          theme.base,
          buttonSpinner ? theme.buttonSize[size] : theme.size[size],
          color === "inverse" ? theme.inverseColor : theme.color,
        )}
        width="800px"
        height="800px"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path fill="currentFill" d="M8,1V2.8A5.2,5.2,0,1,1,2.8,8H1A7,7,0,1,0,8,1Z" />
        </g>
      </svg>
    </div>
  );
}
